import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=786ba71c&scoped=true&"
import script from "./MessageDialog.vue?vue&type=script&lang=js&"
export * from "./MessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=786ba71c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786ba71c",
  null
  
)

export default component.exports